import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextPerformance = createSVG({
    width: 48,
    children: (jsx("path", { d: "M44.5 6v12h-2.361v-7.783l-3.395 5.572h-.276l-3.395-5.555V18h-2.378V6h2.447l3.464 5.674L42.053 6zM31.085 8.263H26.26v2.846h4.688v2.262H26.26V18h-2.38V6h7.204zM19.913 18l-2.43-4.166h-1.81V18h-2.378V6h4.826c2.223 0 4.015 1.783 4.015 3.977 0 1.509-.948 2.863-2.326 3.497L22.48 18zm-4.24-9.789v3.549h2.448c.896 0 1.637-.789 1.637-1.783s-.741-1.766-1.637-1.766zM7.998 6c2.327 0 4.12 1.783 4.12 4.029s-1.793 4.028-4.12 4.028h-2.12V18H3.5V6zm0 5.846c1.017 0 1.758-.789 1.758-1.817 0-1.046-.741-1.818-1.758-1.818h-2.12v3.635z" })),
});

export { IconTextPerformance };
